import {Utilities} from '../../shared/utilities/utilities.model';

export class AlertItemModel {
	date_last_update: string;
	date_rec_ins: string;
	date_read_last_message: string;
	id_dealer: string;
	id_deliverypoint: string;
	id_last_message: string;
	id_last_message_ext: string;
	id_order: string;
	id_senders: string;
	id_sender_ext_last_message: string;
	id_last_sender: string;
	txt_chassis: string;
	txt_direction: string;
	txt_last_message: string;
	txt_last_subject: string;
	txt_plate: string;
	txt_senders: string;
	txt_sender_ext_last_message: string;
	txt_thread_uid: string;
	user_last_update: string;
	user_rec_ins: string;
	val_attachments: string;
	val_messages: string;

	saving = false;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.date_last_update = model.date_last_update;
			this.date_rec_ins = model.date_rec_ins;
			this.date_read_last_message = model.date_read_last_message;
			this.id_dealer = model.id_dealer;
			this.id_deliverypoint = model.id_deliverypoint;
			this.id_last_message = model.id_last_message;
			this.id_last_message_ext = model.id_last_message_ext;
			this.id_order = model.id_order;
			this.id_senders = model.id_senders;
			this.id_sender_ext_last_message = model.id_sender_ext_last_message;
			this.txt_chassis = model.txt_chassis;
			this.txt_direction = model.txt_direction;
			this.txt_last_message = model.txt_last_message;
			this.txt_last_subject = model.txt_last_subject;
			this.txt_plate = model.txt_plate;
			this.txt_senders = model.txt_senders;
			this.txt_sender_ext_last_message = model.txt_sender_ext_last_message;
			this.txt_thread_uid = model.txt_thread_uid;
			this.user_last_update = model.user_last_update;
			this.user_rec_ins = model.user_rec_ins;
			this.val_attachments = model.val_attachments;
			this.val_messages = model.val_messages;
		}
	}
}
